import { render, staticRenderFns } from "./AuthFailures.vue?vue&type=template&id=5dfa6c15&scoped=true"
import script from "./AuthFailures.vue?vue&type=script&lang=js"
export * from "./AuthFailures.vue?vue&type=script&lang=js"
import style0 from "./AuthFailures.vue?vue&type=style&index=0&id=5dfa6c15&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfa6c15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dfa6c15')) {
      api.createRecord('5dfa6c15', component.options)
    } else {
      api.reload('5dfa6c15', component.options)
    }
    module.hot.accept("./AuthFailures.vue?vue&type=template&id=5dfa6c15&scoped=true", function () {
      api.rerender('5dfa6c15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AuthFailures.vue"
export default component.exports